import { useFormState } from '@atlassian/eoc-form';

import { useInitialValues, useRotationUpdate } from '../../../../../../controllers/edit';
import { type FormFields } from '../../../../../../controllers/edit/types';

/*
 * FIX: Warning: Cannot update a component (`%s`) while rendering a different component (`%s`)
 * See: https://ifountain.atlassian.net/browse/TARDIS-8939
 */
export const OnChange = () => {
	const [rotationId] = useInitialValues();
	const { updateRotation, updateRotationDebounced } = useRotationUpdate(rotationId);

	useFormState<FormFields>({
		subscription: {
			active: true,
			hasValidationErrors: true,
			values: true,
		},
		onChange: ({ hasValidationErrors, values, active }) => {
			// Cancel last debounced if validation error occured
			if (hasValidationErrors) {
				updateRotationDebounced.cancel();
				return;
			}

			// TODO: Check the edge cases
			if (!hasValidationErrors) {
				if (active === 'name' || active === 'shiftPeriod') {
					updateRotationDebounced(values);
				} else {
					updateRotation(values);
				}
			}
		},
	});

	return null;
};
